export const sortByPosition = (sources) => sources?.sort((a, b) => (a?.position || 99) - (b?.position || 99));
